import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import SidebarStateProvider from "./components/Sidebar/context/SidebarState";
import './index.css'

import { PrimeReactProvider, PrimeReactContext } from 'primereact/api';
        


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PrimeReactProvider>
    <SidebarStateProvider>
      <App/>
    </SidebarStateProvider>
    </PrimeReactProvider>
   
  </React.StrictMode>
);
